import FhirService from '@lifeomic/phc-web-toolkit/src/services/FhirService';
import {
  REVIEWABLE_RESOURCE_TYPE_LIST,
  type ReviewableResourceType,
} from '@lifeomic/phc-web-toolkit/src/util/extractedResourceReview';

/**
 * A FHIR service per reviewable resource type, so review surfaces can hydrate
 * whatever an extraction persisted. Built from the canonical type list rather
 * than restated per surface: the extraction task audit previously kept its own
 * map and lost `MedicationRequest` when the list grew.
 */
export const reviewableFhirServices = Object.fromEntries(
  REVIEWABLE_RESOURCE_TYPE_LIST.map(resourceType => [
    resourceType,
    new FhirService(resourceType),
  ]),
) as Record<ReviewableResourceType, FhirService<ReviewableResourceType>>;
